(function () {
  var tones = ['bright', 'lamp', 'night'], names = ['Daylight', 'Lamplight', 'Night'];
  var slider = document.getElementById('tone'), out = document.getElementById('tone-name');
  if (!slider) return;
  var current = document.documentElement.dataset.tone || 'bright';
  var i = Math.max(0, tones.indexOf(current));
  slider.value = i; out.textContent = names[i];
  slider.addEventListener('input', function () {
    var t = tones[slider.value];
    document.documentElement.dataset.tone = t;
    out.textContent = names[slider.value];
    try { localStorage.setItem('tone', t); } catch (e) {}
  });
})();
